import type { AxiosInstance } from 'axios';
import type * as IAPI from './interfaces/location';

export class LocationClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  getAzureMapsToken = (): Promise<IAPI.GetAzureMapsToken.Response> => {
    return this.authenticatedClient.post<IAPI.GetAzureMapsToken.Response>('/location/azure-maps-token').then(res => res.data);
  };

  getAzureMapsConfig = (): Promise<IAPI.GetAzureMapsConfig.Response> => {
    return this.authenticatedClient.get<IAPI.GetAzureMapsConfig.Response>('/location/azure-maps-configs').then(res => res.data);
  };
}

export default LocationClient;